import React from "react";
import styled from "styled-components";
function Features({ tagline, headline, description, image, button, reverse }) {
  return (
    <Container reverse={reverse}>
      <Description>
        <TagLine>
          <p>{tagline}</p>
        </TagLine>
        <HeadLine>{headline}</HeadLine>
        <Desc>{description}</Desc>
        <CTA>
          <button>{button}</button>
        </CTA>
      </Description>
      <Image>
        <img src={image} alt="" />
      </Image>
    </Container>
  );
}

const Container = styled.div`
  margin: auto;
  width: 80%;

  display: flex;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "row")};
  padding: 40px 0;
  align-items: center;
  justify-content: center;
  @media only screen and (max-width: 767px) {
    /* Styles */

    width: 100%;
    flex-direction: column;
  }
`;
const Description = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  @media only screen and (max-width: 767px) {
    /* Styles */

    width: 90%;
  }
`;
const Image = styled.div`
  width: 50%;
  @media only screen and (max-width: 767px) {
    /* Styles */

    width: 90%;
  }
  img {
    width: 100%;
  }
`;
const TagLine = styled.div`
  background: #fdecec;
  border-radius: 23px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  height: 45px;
  /* identical to box height, or 100% */

  display: flex;
  align-items: center;

  color: #f55556;

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */

    font-size: 12px;
    width: 140px;
  }
`;
const HeadLine = styled.h2`
  font-family: "Poppins";
  font-style: normal;
  font-weight: bold;
  font-size: 60px;
  line-height: 70px;
  width: 95%;
  /* or 119% */

  letter-spacing: -0.01em;
  margin-bottom: 10px;

  color: #2e2e2e;
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */
    font-size: 40px;
    line-height: 55px;
  }

  @media only screen and (max-width: 767px) {
    /* Styles */

    font-size: 38px;
    line-height: 48px;
    margin-top: 40px;
  }
`;
const Desc = styled.p`
  font-family: "Poppins";
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 30px;
  width: 90%;
  /* or 167% */

  letter-spacing: 0.005em;

  color: #676767;
  margin-bottom: 20px;
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */

    font-size: 14px;
  }

  @media only screen and (max-width: 767px) {
    /* Styles */

    font-size: 13px;
  }
`;
const CTA = styled.div`
  button {
    background: #f86061;
    border-radius: 12px;
    width: 150px;
    height: 55px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    border: none;
    outline: none;
    line-height: 20px;
    /* identical to box height, or 100% */

    text-align: center;

    color: #fffafa;
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      /* Styles */
      font-size: 14px;
      width: 120px;
      height: 45px;
      margin-top: 20px;
    }
  }
`;
export default Features;
